import script from "./BlockPerformance.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockPerformance.vue?vue&type=script&setup=true&lang=js"

import "./BlockPerformance.vue?vue&type=style&index=0&id=50d9d9f2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50d9d9f2"]])

export default __exports__